import * as React from 'react';
import { Form, Formik } from 'formik';
import { Switch } from '../../../../../../components/Switch/Switch';
import { SchoolUserPermission } from '../../../../../../models/schoolUser';
import { ROLE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../consts/user';

interface Props {
  userPermissions: SchoolUserPermission[];
  onCloseClick: () => void;
  onSubmit: (data: SchoolUserPermission[]) => void;
  affectedUsersCount: number;
}

export function UserRevokeRoleForm(props: Props) {
  const { userPermissions } = props;
  const requestInitial = {
    permissions: userPermissions.map(permission => ({ ...permission, isRevoke: false }))
  };
  return (
    <Formik
      onSubmit={values => {
        const revokePermissions = values.permissions.filter(permission => permission.isRevoke);
        const revokePermissionsWithoutIsRevoke = revokePermissions.map(permission => {
          const { isRevoke, ...rest } = permission;
          return { ...rest };
        });
        props.onSubmit(revokePermissionsWithoutIsRevoke);
      }}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="userRoleActionForm">
          <p className="userRoleActionForm__intro">Choose the roles that should be removed from the selected user.</p>
          <div className="userRoleActionForm__summary">
            Revoking roles from {props.affectedUsersCount} {props.affectedUsersCount === 1 ? 'user' : 'users'}.
          </div>
          <span className="userRoleActionForm__label">Assigned roles</span>
          <div className="userRoleActionForm__list">
            {values.permissions.map((permission, index) => {
              return (
                <label key={`revoke_role_${index}`} className="userRoleActionForm__row">
                  <span>{ROLE_SERVER_TO_CLIENT_MAPPING[permission.preset]}</span>
                  <Switch
                    name={`isRevoke_${permission.preset}_${index}`}
                    value={permission.isRevoke}
                    onChange={event => {
                      const permissions = [...values.permissions];
                      permissions[index] = { ...permissions[index], isRevoke: event.target.checked };
                      setFieldValue('permissions', permissions);
                    }}
                  />
                </label>
              );
            })}
          </div>
          <div className="userRoleActionForm__actions">
            <button type="button" className="sit-btn sit-btn--ghost" onClick={props.onCloseClick}>
              Cancel
            </button>
            <button
              type="submit"
              className="sit-btn sit-btn--primary"
              disabled={!values.permissions.some(item => item.isRevoke)}
            >
              Revoke role
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
